import DrawerMenuItemLink from 'Components/Layout/DrawerMenu/DrawerMenuItemLink'
import type { NavLink } from 'Components/Layout/DrawerMenu/types'
import Theme from 'Util/theme'
import ArrowRight from '@mui/icons-material/ArrowRight'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { MenuItem as MuiMenuItem } from '@mui/material'
import Collapse from '@mui/material/Collapse'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import { styled } from '@mui/material/styles'
import { type FC, useState } from 'react'

const StyledMenuItem = styled(MuiMenuItem)(() => ({
  display: 'block',
  padding: 0,
  borderRadius: 8,
  '&:hover': {
    backgroundColor: 'transparent'
  }
}))

const DrawerMenuItem: FC<{
  item: NavLink
  rootUrl: string
  isSubMenu?: boolean
}> = ({ item, rootUrl, isSubMenu = false }) => {
  const { title, link, subMenu } = item
  const [open, setOpen] = useState(true)

  const handleClick: React.MouseEventHandler<HTMLDivElement> = event => {
    if (subMenu) {
      event?.preventDefault()
      setOpen(!open)
    }
  }

  return (
    <StyledMenuItem>
      <DrawerMenuItemLink
        className={subMenu ? '' : 'menu-item'}
        to={subMenu ? { hash: '', pathname: link } : { pathname: link }}
        end={link === rootUrl}
        hasSubMenu={!!subMenu}
      >
        <ListItemButton onClick={handleClick} sx={{ pl: isSubMenu ? 4 : 3, borderRadius: '8px' }}>
          {!subMenu && (
            <ArrowRight
              sx={{ color: Theme.palette.tertiary.main, position: 'absolute', left: '4px' }}
            />
          )}
          <ListItemText
            primary={title}
            sx={{ p: 1 }}
            primaryTypographyProps={{ fontSize: '14px', fontWeight: 600 }}
          />
          {subMenu && (open ? <ExpandLess /> : <ExpandMore />)}
        </ListItemButton>
        {subMenu && (
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="ul" disablePadding>
              {subMenu.map((subMenuItem, i) => (
                <DrawerMenuItem
                  key={`${title}-submenu-${i}`}
                  item={subMenuItem}
                  rootUrl={rootUrl}
                  isSubMenu
                />
              ))}
            </List>
          </Collapse>
        )}
      </DrawerMenuItemLink>
    </StyledMenuItem>
  )
}

export { DrawerMenuItem, DrawerMenuItem as default }
